var _identityMap;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * 根据站点信息和当前origin匹配出需要前往的url
 */

import { message } from 'antd';
import { IDENTITY_TYPE_MAPPING } from "../Types/user";
/**  需要跳转用户中心的域名map */
export var LOGIN_BACK_MAP = {
  /**
   * pc用户中心
   * 对应 门户 {pcDomain} 中台 {midDomain} 机构端 {orgDomain} 个人端 {personalDomain}
   */
  pcDomain: ['pcDomain', 'padDomain', 'midDomain', 'orgDomain', 'personalDomain', 'loginUrl'],
  /**
   * h5用户中心
   * 对应 pad端 {padDomain} 移动端中台 {midMobileDomain} 移动端 {wapDomain}
   */
  wapDomain: ['midMobileDomain', 'wapDomain', 'wapLoginUrl'],
  /**
   * 机构门户pc
   * 对应 机构门户pc {burl}
   */
  burl: ['burl'],
  /**
   * 机构门户h5
   * 对应 机构门户h5 {portalH5Url}
   */
  portalH5Url: ['portalH5Url'],
  /**
   * 资源方用户中心pc
   * 对应 资源方pc {merchantDomain} 资源方中台pc {merchantMidDomain} 课程资源方pc {courseMerchantDomain} 题库资源方pc {questionMerchantDomain}
   *
   * 讲师用户中心pc
   * 对应 讲师pc {lecturerDomain} 讲师中台 {lecturerMidDomain}
   */
  merchantUserDomain: ['merchantDomain', 'merchantMidDomain', 'courseMerchantDomain', 'questionMerchantDomain', 'merchantUserDomain', 'lecturerDomain', 'lecturerMidDomain'],
  /**
   * 讲师用户中h5
   * 对应 讲师h5 {lecturerMobileDomain}
   */
  merchantUserMobileDomain: ['lecturerMobileDomain', 'merchantUserMobileDomain']
};

/**  需要跳转用户中心的路由map */
export var LOGIN_BACK_ROUTER_MAP = {
  /**
   * pc用户中心
   * 对应 门户 {pcDomain} 中台 {midDomain} 机构端 {orgDomain} 个人端 {personalDomain}
   * h5用户中心
   * 对应 pad端 {padDomain} 移动端中台 {midMobileDomain} 移动端 {wapDomain} 移动端用户中心 {wapLoginUrl}
   */
  '/account/user/login': ['pcDomain', 'midDomain', 'orgDomain', 'personalDomain', 'wapDomain'],
  /**
   * pc用户中心
   * 对应 门户 {pcDomain} 中台 {midDomain} 机构端 {orgDomain} 个人端 {personalDomain}
   * h5用户中心
   * 对应 pad端 {padDomain} 移动端中台 {midMobileDomain} 移动端 {wapDomain} 移动端用户中心 {wapLoginUrl}
   */
  // '/user/login': ['padDomain', 'midMobileDomain', 'wapDomain', 'wapLoginUrl'],

  /**
   * 机构门户pc
   * 对应 机构门户pc {burl}
   * 机构门户h5
   * 对应 机构门户h5 {portalH5Url}
   */
  '/user-center/user/login': ['burl', 'portalH5Url'],
  /**
   * 资源方用户中心pc
   * 对应 资源方pc {merchantDomain} 资源方中台pc {merchantMidDomain}
   */
  '/seller/login': ['merchantDomain', 'merchantMidDomain', 'merchantUserDomain'],
  /** 课程资源方pc {courseMerchantDomain} */
  '/seller/login?SourceType=course': ['courseMerchantDomain'],
  /**  题库资源方pc {questionMerchantDomain} */
  '/seller/login?SourceType=question': ['questionMerchantDomain'],
  /**
   * 讲师用户中心pc
   * 对应 讲师pc {lecturerDomain} 讲师中台 {lecturerMidDomain}
   * 讲师用户中h5
   * 对应 讲师h5 {lecturerMobileDomain}
   * 资源方用户中心H5  目前只有讲师身份
   * {merchantUserMobileDomain}
   */
  '/teacher-login': ['lecturerDomain', 'lecturerMidDomain', 'lecturerMobileDomain', 'merchantUserMobileDomain']
};
/** 用户身份对应的路由 */
var identityMap = (_identityMap = {}, _defineProperty(_identityMap, IDENTITY_TYPE_MAPPING.course, '/seller/login?SourceType=course'), _defineProperty(_identityMap, IDENTITY_TYPE_MAPPING.question, '/seller/login?SourceType=question'), _defineProperty(_identityMap, IDENTITY_TYPE_MAPPING.person_teacher_mlh, '/teacher/mlh/login'), _defineProperty(_identityMap, IDENTITY_TYPE_MAPPING.person_teacher_job, '/teacher/job/login'), _identityMap);

/**  需要跳转自身子应用的域名 */
export var SELF_LOGIN_MAP = {
  /**
   * 机构门户pc
   * 对应 机构门户pc {burl}
   */
  burl: ['burl'],
  /**
   * 机构门户h5
   * 对应 机构门户h5 {portalH5Url}
   */
  portalH5Url: ['portalH5Url']
};
/**
 * 通过当前origin 从站点信息里匹配可以前往的用户中心origin
 * @param {GetMapLoginUrlType} params
 * @return {string}
 */
export var getMapLoginUrl = function getMapLoginUrl() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    type: 'storage'
  };
  var _params$type = params.type,
    type = _params$type === void 0 ? 'storage' : _params$type,
    _params$key = params.key,
    key = _params$key === void 0 ? 'siteStore' : _params$key,
    store = params.store,
    identity = params.identity;
  var siteStore = {};
  if (type === 'storage') {
    siteStore = JSON.parse(localStorage.getItem(key) || '{}');
  } else {
    siteStore = store;
  }

  //@ts-ignore
  var _ref = siteStore || {},
    siteData = _ref.siteData;
  var _ref2 = siteData || {},
    _ref2$data = _ref2.data,
    data = _ref2$data === void 0 ? {} : _ref2$data;
  var _ref3 = data || {},
    _ref3$baseInfo = _ref3.baseInfo,
    baseInfo = _ref3$baseInfo === void 0 ? {} : _ref3$baseInfo;
  var alias = baseInfo.alias;
  var originMatchKey = '';
  var matchRouter = '';
  var matchUserKey = '';

  /** 判断当前是否为就业站点 */
  var judgeIsJyAlias = function judgeIsJyAlias(tempAlias) {
    if (tempAlias === 'qznlsz') {
      return true;
    } else {
      return tempAlias.includes('qznlsx');
    }
  };
  var currentDomain = RUN_ENV === 'local' ? localStorage.getItem('currentDomain') : window.origin;
  // 从baseinfo里找到值与域名相同的字段
  Object.keys(baseInfo).find(function (key) {
    if (baseInfo[key].toString().includes(currentDomain)) {
      originMatchKey = key;
      return true;
    } else {
      return false;
    }
  });
  // 找到匹配字段后，通过LOGIN_BACK_MAP匹配当前域名可以前往的用户中心
  // 机构门户pc，前往自身用户中心子应用
  // 机构门户h5，前往自身用户中心子应用
  if (originMatchKey) {
    if (SELF_LOGIN_MAP[originMatchKey]) {
      // 当匹配到需要跳转自身子应用的域名 返回跳转自身路由
      return "/user-center/user/login";
    } else {
      // 从LOGIN_BACK_MAP匹配出需要前往的用户中心地址
      Object.keys(LOGIN_BACK_MAP).find(function (key) {
        if (LOGIN_BACK_MAP[key].includes(originMatchKey)) {
          matchUserKey = key;
          return true;
        } else {
          return false;
        }
      });
      /** 根据域名获取登录的 router */
      Object.keys(LOGIN_BACK_ROUTER_MAP).find(function (key) {
        if (LOGIN_BACK_ROUTER_MAP[key].includes(originMatchKey)) {
          matchRouter = key;
          return true;
        } else {
          return false;
        }
      });
      /** 资源方用户中心有传身份需要跳转到对应身份登录页 */
      if (identity && identityMap[identity]) {
        matchRouter = identityMap[identity];
      }
      if (matchRouter === '/teacher-login') {
        matchRouter = '/404';
        message.warning('缺少身份信息');
      }
      /** 当前为本地调试时，前往用户中心本地url */
      var mobileDomain = ['merchantUserMobileDomain', 'wapDomain'];
      var locationDomain = mobileDomain.includes(matchUserKey) ? 'http://localhost:9009' : 'http://localhost:8011';
      RUN_ENV === 'local' ? baseInfo[matchUserKey] = locationDomain : '';
      /** 当前站点为guizhou 且当前origin匹配的登录key是 lecturerMobileUserDomain时 */
      if ((alias === 'guizhou' || alias === 'henan') && matchUserKey === 'lecturerMobileUserDomain') {
        return baseInfo.pcDomain ? "".concat(baseInfo.pcDomain, "/account/user/login") : '';
      } else {
        // 当前为求职站点,并且当前域名在padDomain配置中时为工作台项目,需要前往pc用户中心登录
        if (judgeIsJyAlias(alias) && originMatchKey === 'padDomain') {
          return baseInfo.pcDomain ? "".concat(baseInfo.pcDomain, "/account/user/login") : '';
        } else {
          return baseInfo[matchUserKey] ? "".concat(baseInfo[matchUserKey]).concat(matchRouter) : '';
        }
      }
    }
  } else {
    return '';
  }
};